import { Redirect } from "@reach/router";
import useAuth from "hooks/useAuth";
import React from "react";

export default function Home(props: ReachPathProps) {
  const { user } = useAuth();
  if (!user) return <Redirect from="/" to="/login" noThrow />;
  return <Redirect from="/" to="suppliers/dashboard" noThrow />;
}
